import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEventDelete, useEventUser } from '@features/events';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { DropdownItem, useMenuDropdown } from '@shared/ui';
import { DropdownMenuWithButton } from '@shared/ui/menus/dropdown-menu/ui';
import { checkEventEnd } from '@src/library/helpers/events/dateSets';
import { usePublicate, useShare } from '@src/library/hooks/events';
import type { Event } from '@src/library/models/events';

interface Props {
  event: Event;
  onDelete: (id: number) => void;
}

export const Menu = ({ event, onDelete }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { permissions } = useModuleByCodeParam();
  const { isAuthor, isAuth } = useEventUser(event);

  const { deleteEvent } = useEventDelete();
  const { goToPublicationPage } = usePublicate();
  const { openShare } = useShare();

  const { menuRef, onClose, handleToggleDropdown, isMenuOpen } = useMenuDropdown({});

  const handleAction = useCallback(
    (action: () => void) => {
      action();
      onClose();
    },
    [onClose]
  );

  const handleClickDelete = (id: number) => {
    deleteEvent(id, onDelete);
  };

  return (
    <DropdownMenuWithButton
      isMenuOpen={isMenuOpen}
      onMenuBtnClick={handleToggleDropdown}
      menuRef={menuRef}
    >
      {isAuthor && (
        <DropdownItem onClick={() => handleAction(() => goToPublicationPage(event.id))}>
          Публикация
        </DropdownItem>
      )}
      <DropdownItem onClick={() => handleAction(() => openShare(event.id))}>
        Поделиться
      </DropdownItem>
      {isAuthor && (
        <DropdownItem
          onClick={() => handleAction(() => navigate(`/events/${code}/${event.id}/edit`))}
        >
          Изменить
        </DropdownItem>
      )}
      {isAuthor && checkEventEnd(event.time_to) && (
        <DropdownItem
          onClick={() => navigate(`/events/${code}/create`, { state: { copyEventId: event.id } })}
        >
          Дублировать
        </DropdownItem>
      )}
      {isAuthor && <DropdownItem onClick={() => handleClickDelete(event.id)}>Удалить</DropdownItem>}
    </DropdownMenuWithButton>
  );
};
